
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../host.css"; // Assuming host styles are global or this file exists

const WebinarDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const webinar = location.state?.webinar;

    if (!webinar) {
        return (
            <div className="container-fluid dashboard-full-height d-flex flex-column justify-content-center align-items-center">
                <div className="alert alert-warning" role="alert">
                    No webinar details found.
                </div>
                <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 mb-4">
                    <button
                        className="btn btn-link text-decoration-none p-0 d-flex align-items-center gap-2"
                        onClick={() => navigate(-1)}
                        style={{ color: '#6b7280', fontSize: '16px' }}
                    >
                        <span>←</span> Back to Dashboard
                    </button>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-lg-10 col-xl-8">
                    <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                        {/* Cover Image */}
                        {webinar.coverImage && (
                            <div style={{ maxHeight: '400px', overflow: 'hidden' }}>
                                <img
                                    src={webinar.coverImage}
                                    alt={webinar.title}
                                    className="w-100 h-100"
                                    style={{ objectFit: 'cover' }}
                                />
                            </div>
                        )}

                        <div className="card-body p-4 p-md-5">
                            {/* Title */}
                            <h1 className="lato-bold-32 mb-4 text-dark">{webinar.title}</h1>

                            {/* Date & Time Badge */}
                            <div className="d-inline-flex align-items-center gap-2 px-3 py-2 bg-light rounded-3 mb-4">
                                <span className="fs-5">📅</span>
                                <span className="lato-medium-16 text-secondary">{webinar.date}</span>
                            </div>

                            {/* Description */}
                            {webinar.description && (
                                <div className="mb-5">
                                    <h4 className="lato-bold-20 mb-3 text-dark">About this webinar</h4>
                                    <div
                                        className="text-secondary"
                                        style={{ lineHeight: '1.8', fontSize: '16px' }}
                                        dangerouslySetInnerHTML={{ __html: webinar.description }}
                                    />
                                </div>
                            )}

                            {/* Action Button */}
                            {webinar.link && (
                                <div className="d-grid d-md-block">
                                    <a
                                        href={webinar.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-primary btn-lg rounded-pill px-5 text-white fw-bold"
                                        style={{
                                            background: "linear-gradient(to right, #61dde9 0%, #a685e2 100%)",
                                            border: "none"
                                        }}
                                    >
                                        Join Webinar
                                    </a>
                                    {/* <div className="mt-2 text-muted small">
                                        Link: <a href={webinar.link} target="_blank" rel="noopener noreferrer" className="text-primary">{webinar.link}</a>
                                    </div> */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WebinarDetails;
